import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateChargingServiceTags } from '../../api/charging-service.ts';
import { UpdateChargingServiceTagsRequest } from '../../api/requests/charging-service-request.ts';

export default function useUpdateChargingServiceTags(): UseMutationResult<
  Awaited<ReturnType<typeof updateChargingServiceTags>>,
  Error,
  UpdateChargingServiceTagsRequest
> {
  return useMutation({
    mutationFn: updateChargingServiceTags,
  });
}
